import React, { useState } from 'react';
import { EyeTwoTone } from '@ant-design/icons';
import { Drawer, Descriptions, Form } from 'antd';

const ShowCapability = ({ item }) => {
    const [Model_visible, setModel_visible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setModel_visible(true);
    };

    const hideModal_Cancel = () => {
        setModel_visible(false);
        form.resetFields();
    };

    return (
        <>
            <EyeTwoTone key="view" onClick={showModal} />
            <Drawer
                title={item.name}
                visible={Model_visible}
                closable={true}
                placement={window.innerWidth <= 500 ? 'top' : 'right'}
                onClose={hideModal_Cancel}
                okText="Submit"
                cancelText="Close"
            >
                <Descriptions column={1}>
                    <Descriptions.Item label="Name">{item.name}</Descriptions.Item>
                </Descriptions>
            </Drawer>
        </>
    );
};

export default ShowCapability;
